import React from "react";

const INITAL_SYMBOL = Symbol();
export const useManagedProp = (aProps, aInitilizer) => {
  const ref = React.useRef(null);
  if (ref.current === null) {
    const value = aInitilizer(aProps);
    if (!value || typeof value !== "object") {
      throw new Error("initalizer must return object!..");
    }
    const inital = {};
    for (let key of Object.keys(value)) {
      inital[key] = aProps[key];
    }
    value[INITAL_SYMBOL] = inital;
    ref.current = value;
  } else {
    const current = ref.current;
    const inital = current[INITAL_SYMBOL];
    const modified = {};
    for (let [key, value] of Object.entries(inital)) {
      const n = aProps[key];
      if (!Object.is(value, n)) {
        modified[key] = n;
      }
    }
    const keys = Object.keys(modified);
    if (keys.length > 0) {
      const values = aInitilizer(modified, inital);
      for (let key of keys) {
        const value = values[key];
        inital[key] = value;
        current[key] = value;
      }
    }
  }
  return ref.current;
};
export default useManagedProp;
